import { FC } from "react";

interface MarginaliaInfoBoxProps {
	title: string;
	body: string;
}

const MarginaliaInfoBox: FC<MarginaliaInfoBoxProps> = ({ title, body }) => (
	<div className="border border-[#ccc] rounded-lg px-4 py-3 bg-white">
		<p className="text-xs font-bold uppercase tracking-wider text-[#999] mb-1">{title}</p>
		<p className="text-sm leading-relaxed text-[#666]" dangerouslySetInnerHTML={{ __html: body }} />
	</div>
);

export { MarginaliaInfoBox };
